import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { InitUserGQL } from './user.query.generated';
import { UserService } from './user.service';

export const userGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const user$ = inject(InitUserGQL)
    .fetch({}, { errorPolicy: 'ignore', fetchPolicy: 'no-cache' })
    .pipe(map(r => r.data.me));
  return user$.pipe(
    map(user => {
      if (user) {
        userService.user = { ...userService.user, ...user };
        return true;
      } else {
        userService.notLoggedBackTo = state.url;
        return router.parseUrl('/unauthorized');
      }
    }),
  );
};
